// extracted by mini-css-extract-plugin
export var mainNav = "MainNavigation-module--main-nav--14fvE";
export var link = "MainNavigation-module--link--3xUqV";
export var hamburger = "MainNavigation-module--hamburger--2F214";
export var rotate = "MainNavigation-module--rotate--3tzLW";
export var hideMenu = "MainNavigation-module--hide-menu--2S5wG";
export var showMenu = "MainNavigation-module--show-menu--38PQg";